<template>
  <v-form ref="form">
    <div class="mb-3">
      Vui lòng chọn <span class="font-weight-medium">Lớp</span>, <span class="font-weight-medium">Học kỳ</span> và
      <span class="font-weight-medium">Đầu điểm</span> cần xuất file điểm
    </div>
    <v-row>
      <v-col cols="4">
        <AutocompleteSemester
          v-model="semesterData"
          placeholder="Chọn học kỳ"
          label="Học kỳ"
          outlined
          dense
          hide-details
          required
          :rules="[$rules.required]"
        />
      </v-col>
      <v-col cols="4">
        <GradeClassStudentSelect
          disableGradeSelect
          disableStudentSelect
          :classCol="{
            sm: 12,
            md: 12
          }"
          @changed="onClassSelect"
          :rules="[$rules.required]"
        />
      </v-col>
      <v-col cols="4">
        <v-autocomplete
          :items="[
            { title: 'ĐĐGgk', value: 'factor-2' },
            { title: 'ĐĐGck', value: 'factor-3' }
          ]"
          item-text="title"
          item-value="value"
          clearable
          return-object
          v-model="factorData"
          outlined
          dense
          required
          label="Đầu điểm"
          :rules="[$rules.required]"
        />
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import GradeClassStudentSelect from '@/components/basic/filter/GradeClassStudentSelect.vue'
import AutocompleteSemester from '@/components/basic/input/AutocompleteSemester'
export default {
  components: { GradeClassStudentSelect, AutocompleteSemester },
  data: () => ({ classData: null, semesterData: null, factorData: null }),
  methods: {
    validate() {
      return this.$refs.form.validate()
    },
    onClassSelect(data) {
      this.classData = data.class
    },
    getData() {
      return {
        classData: this.classData,
        semesterData: this.semesterData,
        factorData: this.factorData
      }
    }
  }
}
</script>
